import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { H4 } from 'UIComponents/elements/headings';

// @ts-expect-error Library not yet migrated

import ProfessorRow from '../ProfessorRow';
// @ts-expect-error Library not yet migrated
import { getSelectedLanguageFiltersFromRoute } from '../../selectors/routeSelectors';
import { getProfessorDescription } from '../../utils/ContentUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProfessorList = ({
  className,
  professors,
  i18nHeading,
  handleOrganisationUrlClick
}) => {
  const location = useLocation();
  const languages = getSelectedLanguageFiltersFromRoute({}, {
    location
  });
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('professor-list', className),
    children: [/*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: i18nHeading,
        options: {
          count: professors.length
        }
      })
    }), professors.map(professor => /*#__PURE__*/_jsx(ProfessorRow, {
      description: getProfessorDescription(professor, languages.first()),
      handleOrganisationUrlClick: handleOrganisationUrlClick,
      id: professor.get('id'),
      image: professor.get('image'),
      jobTitle: professor.get('jobTitle'),
      linkedinUrl: professor.get('linkedinUrl'),
      name: professor.get('name'),
      organisation: professor.get('organisation'),
      organisationUrl: professor.get('organisationUrl'),
      xUrl: professor.get('twitterUrl')
    }, professor.get('id')))]
  });
};
export default ProfessorList;